import { createRoute } from '@tanstack/react-router';
import { RezervacePage } from '@/modules/pujcovna/RezervacePage';
import { parseRezervaceUrlSearch } from '@/modules/pujcovna/rezervace-url';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/pujcovna/rezervace',
  validateSearch: parseRezervaceUrlSearch,
  component: RezervacePage,
});
